{
  "name": "frontend-v2",
  "version": "2.2641.4-5217",
  "scripts": {
    "postinstall": "patch-package",
    "ng": "ng",
    "debug": "ng serve --ssl --ssl-key ./localhost.key  --ssl-cert ./localhost.crt --configuration=debug",
    "start": "ng serve --ssl --ssl-key ./localhost.key  --ssl-cert ./localhost.crt --configuration=development",
    "starttest": "ng serve --ssl --ssl-key ./localhost.key  --ssl-cert ./localhost.crt --configuration=test",
    "startacc": "ng serve --ssl --ssl-key ./localhost.key  --ssl-cert ./localhost.crt --configuration=acceptation",
    "startprod": "ng serve --ssl --ssl-key ./localhost.key  --ssl-cert ./localhost.crt --configuration=production",
    "unittest-than-build": "npm run nonwatched-test && npm run build-development",
    "build-development": "ng build --configuration=development",
    "build": "npm run build-development",
    "buildtest": "ng build --configuration=test",
    "buildacc": "ng build --configuration=acceptation",
    "buildprod": "ng build --configuration=production",
    "watch": "ng build --watch --configuration=development",
    "test": "ng test",
    "playwright": "npx playwright test",
    "playwright-ui": "npx playwright test --ui",
    "nonwatched-test": "ng test --no-watch"
  },
  "private": true,
  "dependencies": {
    "@almothafar/angular-signature-pad": "^5.0.1",
    "@angular/animations": "^22.1.1",
    "@angular/cdk": "^22.1.2",
    "@angular/common": "^22.1.1",
    "@angular/compiler": "^22.1.1",
    "@angular/core": "^22.1.1",
    "@angular/forms": "^22.1.1",
    "@angular/localize": "^22.1.1",
    "@angular/material": "^22.1.2",
    "@angular/platform-browser": "^22.1.1",
    "@angular/platform-browser-dynamic": "^22.1.1",
    "@angular/router": "^22.1.1",
    "@danielmoncada/angular-datetime-picker": "^22.0.0",
    "@microsoft/applicationinsights-web": "^3.1.0",
    "@microsoft/signalr": "^8.0.7",
    "@ng-bootstrap/ng-bootstrap": "^21.0.0",
    "@ngx-translate/core": "^14.0.0",
    "@ngx-translate/http-loader": "^7.0.0",
    "@playwright/test": "^1.55.0",
    "@popperjs/core": "^2.11.5",
    "@types/qrcode": "^1.5.5",
    "angular-auth-oidc-client": "^19.0.2",
    "angular2-draggable": "^16.0.0",
    "angularx-qrcode": "^22.0.1",
    "autoprefixer": "^10.4.7",
    "bootstrap": "^5.3.8",
    "bootstrap-icons": "^1.11.2",
    "chart.js": "^4.4.0",
    "dotenv": "^17.2.2",
    "file-saver": "^2.0.5",
    "google-libphonenumber": "^3.2.44",
    "imapflow": "^1.0.196",
    "intl-tel-input": "^19.5.7",
    "ngx-bootstrap": "^22.0.0",
    "ngx-chips": "^3.0.0",
    "ngx-filter-pipe": "^2.1.2",
    "ngx-infinite-scroll": "^22.0.0",
    "ngx-intl-tel-input": "^17.0.0",
    "ngx-panzoom": "^19.0.0",
    "ngx-skeleton-loader": "^13.0.0",
    "npm": "^11.6.1",
    "path-browserify": "^1.0.1",
    "rxjs": "~7.5.0",
    "tslib": "^2.3.0",
    "url": "^0.11.0",
    "zone.js": "^0.15.1"
  },
  "devDependencies": {
    "@angular/build": "^22.1.3",
    "@angular/cli": "^22.1.3",
    "@angular/compiler-cli": "^22.1.1",
    "@types/file-saver": "^2.0.5",
    "@types/jasmine": "~3.10.0",
    "@types/lodash": "^4.14.182",
    "@types/node": "^12.11.1",
    "istanbul-lib-instrument": "^6.0.3",
    "jasmine-core": "~4.0.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.1.0",
    "karma-coverage": "~2.1.0",
    "karma-jasmine": "~4.0.0",
    "karma-jasmine-html-reporter": "~1.7.0",
    "karma-junit-reporter": "^2.0.1",
    "patch-package": "^8.0.1",
    "puppeteer": "^25.6.0",
    "typescript": "^6.0.3"
  }
}
